export interface Config {
    [key: string]: any;
    default_language: "sv-SE"|"en-US";
}
let default_config: Config = {
    api: {
        rt: {
            api_uri: process.env.REACT_APP_RT_API_URI || 'https://rt.vl.allbin.se'
        }
    },
    slack: {
        webhook_uri: process.env.REACT_APP_SLACK_WEBHOOK_URI || 'https://hooks.slack.com/services/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'
    },
    google: {
        maps: {
            api_key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyA0tp0r6ImLSnn9vy4zXjZWar1F3U5eOaY',
            styles: [
                {
                    "featureType": "administrative",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                }
            ]
        }
    },
    notifications: process.env.REACT_APP_NOTIFICATION_CONFIG ? JSON.parse(process.env.REACT_APP_NOTIFICATION_CONFIG) : {
        url: 'wss://rt.vl.allbin.se/notifications/websocket'
    },
    service_name: process.env.REACT_APP_SERVICE_NAME || "rt_map_ui",
    production: process.env.NODE_ENV === "production",

    send_errors_to_slack_in_dev: false,

    default_map_position: { lat: 59.2858673, lng: 14.3370854 },
    default_map_zoom: 8,

    default_language: "en-US",

    update_check_timer: 600000 //ms
};

export default default_config;



// WEBPACK FOOTER //
// ./src/default_config.ts